<template>
  <div class="pending-payment-container">
    <div class="payment-status-card">
      <div class="status-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <h1>Pembayaran Sedang Diproses</h1>
      <p class="status-message">
        Pembayaran Anda sedang diproses oleh sistem. Kami akan mengirimkan notifikasi
        begitu pembayaran berhasil diverifikasi.
      </p>
      <div class="payment-details">
        <div class="detail-row">
          <span class="detail-label">ID Transaksi:</span>
          <span class="detail-value">{{ transactionId }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Metode Pembayaran:</span>
          <span class="detail-value">{{ paymentMethod }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Jumlah:</span>
          <span class="detail-value">{{ amount }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Estimasi Waktu:</span>
          <span class="detail-value">{{ estimatedTime }}</span>
        </div>
      </div>

      <div v-if="paymentMethod === 'bank_transfer'" class="bank-instructions">
        <h3>Instruksi Transfer Bank</h3>
        <ol>
          <li>Buka aplikasi mobile banking atau internet banking Anda</li>
          <li>Masukkan nomor virtual account yang diberikan</li>
          <li>Transfer sesuai jumlah yang tertera</li>
          <li>Simpan bukti transfer</li>
        </ol>
      </div>
      <button class="btn-primary" @click="goToHome">
        Kembali ke Beranda
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PendingPayment',
  data() {
    const method = this.$route.query.payment_type || 'N/A';
    const processingTimes = {
      'bank_transfer': '1-3 jam kerja',
      'credit_card': '1-5 menit',
      'gopay': '1-15 menit',
      'shopeepay': '1-15 menit',
      'default': '1-24 jam'
    };

    return {
      transactionId: this.$route.query.order_id || 'N/A',
      paymentMethod: method,
      amount: this.$route.query.gross_amount
        ? `Rp ${parseInt(this.$route.query.gross_amount).toLocaleString('id-ID')}`
        : 'N/A',
      estimatedTime: processingTimes[method] || processingTimes.default,
      refreshInterval: null,
      lastChecked: new Date()
    };
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
    checkPaymentStatus() {
      this.$axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/payments/status/${this.transactionId}`)
        .then(response => {
          if (response.data.status === 'settlement') {
            clearInterval(this.refreshInterval);
            this.$router.push('/payment-success');
          }
          this.lastChecked = new Date();
        });
    }
  },
  mounted() {
    // Check status every 30 seconds for bank transfers, 10 seconds for others
    const interval = this.paymentMethod === 'bank_transfer' ? 30000 : 10000;
    this.refreshInterval = setInterval(this.checkPaymentStatus, interval);
  },
  beforeUnmount() {
    clearInterval(this.refreshInterval);
  }
};
</script>

<style scoped>
.pending-payment-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  padding: 2rem;
}

.payment-status-card {
  max-width: 500px;
  width: 100%;
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  text-align: center;
}

.status-icon {
  margin-bottom: 1.5rem;
}

h1 {
  font-size: 1.5rem;
  color: #1f2937;
  margin-bottom: 1rem;
}

.status-message {
  color: #6b7280;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.payment-details {
  background: #f9fafb;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 2rem;
  text-align: left;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.detail-label {
  font-weight: 500;
  color: #4b5563;
}

.detail-value {
  color: #1f2937;
  font-weight: 600;
}

.btn-primary {
  width: 100%;
  padding: 0.75rem;
  background-color: #488e71;
  color: white;
  border: none;
  border-radius: 5px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-primary:hover {
  background-color: #3a7259;
}

.bank-instructions {
  margin: 1.5rem 0;
  padding: 1rem;
  background: #fff8e6;
  border-radius: 8px;
  text-align: left;
}

.bank-instructions h3 {
  font-size: 1rem;
  color: #92400e;
  margin-bottom: 0.75rem;
}

.bank-instructions ol {
  padding-left: 1.5rem;
  color: #78350f;
}

.bank-instructions li {
  margin-bottom: 0.5rem;
}

.status-update {
  font-size: 0.875rem;
  color: #6b7280;
  margin-top: 1rem;
}
</style>